import setHtml from './setHtml';
import Tooltip from 'ui/components/Tooltip';

/**
 * @function injectLegalAndTooltips
 * @description Given a string, return a single React node with legal and tooltips injected
 * Example input: "No throttling or data caps {data-caps} plus premium eero router included[eero]"
 */
export const injectLegalAndTooltips = ( copy: string ) => {
  // avoids erroring if using JSX </> syntax
  if ( typeof copy !== 'string' ) return copy;

  const legalElementRegex = /\[.*?\]/g; // in the example input above this regex would match "[eero]"
  const tooltipElementRegex = /\{.*?\}/g; // this regex would match "{data-caps}"
  const containsLegal = legalElementRegex.test( copy );
  const containsTooltips = tooltipElementRegex.test( copy );

  if ( containsLegal ) {
    copy = copy.replaceAll( legalElementRegex, ( match ) => {
      const legalHash = match.substring( 1, match.length - 1 );
      return `<span data-legal="${ legalHash }"></span>`;
    } );
  }

  if ( ! containsTooltips ) return <span { ...setHtml( copy ) } />;

  const tooltipCodes = copy.match( tooltipElementRegex );
  const split = copy.split( tooltipElementRegex );
  const nodes: any = [];

  split.forEach( ( subcopy, i ) => {
    const code = tooltipCodes ? tooltipCodes[ i ] : null;
    nodes.push( <span { ...setHtml( subcopy ) } key={ `copy-${ i }` } /> );
    if ( code ) {
      const tooltipContent = code.substring( 1, code.length - 1 );
      nodes.push( <Tooltip content={ tooltipContent } key={ `tooltip-${ i }` } width="14px" height="14px"/> );
    }
  } );

  return (
    <>
      { nodes }
    </>
  );
};
